import {Button, Form, InputGroup, Modal} from "react-bootstrap";
import React from "react";

export function DynamicBox({label, isInvalid, feedback, onClick, button, className, children}) {
    return <Form.Group className={className}>
        <Form.Label column="">{label}</Form.Label>
        <div className={`p-1 rounded ${isInvalid && "border-danger"}`}>
            <div className="d-flex flex-wrap gap-2">
                {children}
            </div>
            <Button variant="success" size="sm" onClick={onClick}><i className="bi bi-plus me-2"/>{button}</Button>
        </div>

        <Form.Control type="hidden" isInvalid={isInvalid}></Form.Control>
        <Form.Control.Feedback type="invalid">{isInvalid && feedback}</Form.Control.Feedback>
    </Form.Group>
}

export function DynamicDialog({title, show, onHide, filter, setFilter, children}) {
    function handleOnHide() {
        onHide()
        setFilter("")
    }

    return <>
        <Modal show={show} onHide={handleOnHide} scrollable>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Footer>
                <InputGroup hasValidation>
                    <Form.Control id="FilterId" name="filter" placeholder="Search..." autoComplete="off"
                                  value={filter}
                                  onChange={e => setFilter(e.target.value)}
                                  autoFocus
                    />
                    <Button variant="outline-secondary" onClick={() => setFilter("")}><i className="bi bi-x-lg"/></Button>
                </InputGroup>
                <Form.Text>{children[0]}</Form.Text>
            </Modal.Footer>

            <Modal.Body>
                {children[1]}
            </Modal.Body>
        </Modal>
    </>
}